import { DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PersonalInfoForm } from "../personal-info/PersonalInfoForm";
import { useTranslation } from "react-i18next";
import { EditDialogContentProps } from "../types";

export const EditDialogContent = ({ profile, onUpdate }: EditDialogContentProps) => {
  const { t } = useTranslation();

  return (
    <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle>{t('profile.editDialog.title')}</DialogTitle>
      </DialogHeader>
      
      <div className="space-y-6 py-4">
        <PersonalInfoForm 
          profile={profile} 
          onUpdate={onUpdate} 
        />
      </div>
    </DialogContent>
  );
};